import _extends from '@babel/runtime/helpers/extends';
import { Tooltip, IconButton } from '@archer-technologies/ui-components';
import { createElement } from 'react';
import { Plugin, Template, TemplatePlaceholder, TemplateConnector } from '@devexpress/dx-react-core';
var pluginDependencies = [{
  name: 'Toolbar'
}, {
  name: 'FilteringState'
}];

var ToolbarClearFilters = function ToolbarClearFilters(_ref) {
  var messages = _ref.messages,
      disabled = _ref.disabled,
      handleClearFilters = _ref.handleClearFilters;
  var toolTipProps = {
    title: messages.clearFilters
  };
  var iconButtonProps = {
    icon: 'ClearFilter',
    label: messages.clearFilters,
    disabled: disabled
  };

  var createButtonComponent = function createButtonComponent(onClick) {
    return /*#__PURE__*/createElement(Tooltip, toolTipProps, /*#__PURE__*/createElement(IconButton, _extends({
      onClick: onClick
    }, iconButtonProps, {
      "aria-label": messages && messages.clearFilters ? messages.clearFilters : 'Clear Filters'
    })));
  };

  return /*#__PURE__*/createElement(Plugin, {
    name: "toolbarClearFilters",
    dependencies: pluginDependencies
  }, /*#__PURE__*/createElement(Template, {
    name: "toolbarContent"
  }, /*#__PURE__*/createElement(TemplatePlaceholder, null), /*#__PURE__*/createElement(TemplateConnector, null, function (_ref2, _ref3) {
    var filters = _ref2.filters;
    var changeColumnFilter = _ref3.changeColumnFilter;
    return filters !== null && filters !== void 0 && filters.length ? createButtonComponent(function () {
      return handleClearFilters(filters, changeColumnFilter);
    }) : null;
  })));
};

export { ToolbarClearFilters };